{
  "familyId": "GELD-TELLEN",
  "questions": [
    {
      "id": "GELD-TELLEN-TF-001",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen over geldbedragen waar of onwaar?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "€ 3,25 is meer dan € 3,20", "isTrue": true },
          { "text": "€ 2,99 is meer dan € 3,05", "isTrue": false },
          { "text": "€ 3,05 is minder dan € 3,25", "isTrue": true },
          { "text": "€ 3,20 is hetzelfde als € 3,02", "isTrue": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bedragen vergelijken",
            "content": "Vergelijk eerst de euro's (het getal vóór de komma). Als die gelijk zijn, vergelijk dan de centen (het getal ná de komma). Het grootste getal is het meest.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "geld_vergelijken_series",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Bij het vergelijken van geldbedragen kijk je eerst naar de euro's (vóór de komma). Als die gelijk zijn, vergelijk je de centen (ná de komma). € 3,25 heeft 25 cent, dat is meer dan € 3,20 (20 cent). € 2,99 heeft maar 2 euro, dus dat is minder dan € 3,05 (3 euro).",
        "solutionSteps": [
          "Stelling 1: € 3,25 vs € 3,20 → Beide 3 euro, dus vergelijk centen: 25 > 20 → WAAR",
          "Stelling 2: € 2,99 vs € 3,05 → 2 euro < 3 euro → ONWAAR",
          "Stelling 3: € 3,05 vs € 3,25 → Beide 3 euro, dus vergelijk centen: 5 < 25 → WAAR",
          "Stelling 4: € 3,20 vs € 3,02 → Beide 3 euro, maar 20 cent ≠ 2 cent → ONWAAR"
        ]
      }
    },
    {
      "id": "GELD-TELLEN-TF-002",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen over euro en centen waar of onwaar?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "€ 1,35 is hetzelfde als 135 cent", "isTrue": true },
          { "text": "1 euro is 10 cent", "isTrue": false },
          { "text": "€ 2,50 is hetzelfde als 250 cent", "isTrue": true },
          { "text": "50 cent is een halve euro", "isTrue": true },
          { "text": "€ 0,75 is hetzelfde als 7 cent", "isTrue": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Euro en cent omrekenen",
            "content": "Onthoud: 1 euro = 100 cent. De cijfers voor de komma zijn euro's (×100), de cijfers na de komma zijn centen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "geld_euro_cent_omrekenen_series",
      "variantIndex": 2,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Om euro's om te rekenen naar centen, vermenigvuldig je met 100. € 1,35 = 1 × 100 + 35 = 135 cent. 1 euro = 100 cent (niet 10!). 50 cent is de helft van 100 cent, dus een halve euro.",
        "solutionSteps": [
          "Stelling 1: € 1,35 = 1 × 100 + 35 = 135 cent → WAAR",
          "Stelling 2: 1 euro = 100 cent (niet 10) → ONWAAR",
          "Stelling 3: € 2,50 = 2 × 100 + 50 = 250 cent → WAAR",
          "Stelling 4: 50 cent = halve euro (100 ÷ 2 = 50) → WAAR",
          "Stelling 5: € 0,75 = 75 cent (niet 7) → ONWAAR"
        ]
      }
    },
    {
      "id": "GELD-TELLEN-TF-003",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen over geld optellen waar of onwaar?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "2 euro + 50 cent + 20 cent = € 2,70", "isTrue": true },
          { "text": "€ 5 + € 2 + 50 cent = € 7,50", "isTrue": true },
          { "text": "3 × 50 cent = € 2,00", "isTrue": false },
          { "text": "€ 1 + € 1 + 50 cent + 50 cent = € 3,00", "isTrue": true },
          { "text": "€ 2 + 75 cent = € 2,07", "isTrue": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Geld optellen",
            "content": "Tel eerst alle euro's op, dan alle centen. Reken centen om naar euro's als je meer dan 100 cent hebt (100 cent = € 1).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "geld_optellen_series",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bij geld optellen tel je eerst de euro's, dan de centen. Let op: 100 cent = € 1. Dus 3 × 50 cent = 150 cent = € 1,50 (niet € 2,00). En € 2 + 75 cent = € 2,75 (niet € 2,07 — de 75 komt achter de komma).",
        "solutionSteps": [
          "Stelling 1: 2 euro + 50c + 20c = € 2 + 70c = € 2,70 → WAAR",
          "Stelling 2: € 5 + € 2 + 50c = € 7 + 50c = € 7,50 → WAAR",
          "Stelling 3: 3 × 50c = 150c = € 1,50 (niet € 2,00) → ONWAAR",
          "Stelling 4: € 1 + € 1 + 50c + 50c = € 2 + 100c = € 2 + € 1 = € 3,00 → WAAR",
          "Stelling 5: € 2 + 75c = € 2,75 (niet € 2,07) → ONWAAR"
        ]
      }
    }
  ]
}